export enum CL_COUNTRY {
  MX = "MX",
  CO = "CO",
  PE = "PE",
}
